import RGL, { WidthProvider } from "react-grid-layout";

import { DEFAULT_DASHBOARD } from "../../DEFAULT_DASHBOARD.const";
import { FAKE_WIDGETS_DATA } from "../../FAKE_WIDGETS_DATA.const";
import { DASHBOARD_NUM_COLUMNS } from "../../constants";
import { joinWidgets } from "../../utils/joinWidgets";
import { DashboardViewWidget } from "../DashboardViewWidget/DashboardViewWidget";
import styles from "./DashboardView.module.scss";

const RGLComponent = WidthProvider(RGL);

/**
 * Read-only Google Dashboard rendered with hardcoded sample data. Used by
 * the upsell preview when the user has access to the feature but hasn't
 * connected Google Analytics or created their first dashboard yet. Reuses
 * the live `DashboardViewWidget` so the preview matches what the user will
 * actually see post-setup.
 */
export const DashboardPreview = () => {
  const widgetConfigs = DEFAULT_DASHBOARD.properties?.widgets ?? [];
  const widgets = joinWidgets(widgetConfigs, FAKE_WIDGETS_DATA);

  const layout: RGL.Layout[] = widgets.map((widget) => ({
    i: widget.id,
    ...widget.config.metadata.placement,
    maxH: 2,
    static: true,
  }));

  return (
    <div className={styles.page}>
      <div className={styles.rglWrapper}>
        <RGLComponent
          layout={layout}
          cols={DASHBOARD_NUM_COLUMNS}
          rowHeight={300}
          margin={[16, 16]}
          isResizable={false}
          isDraggable={false}
        >
          {widgets.map((widget) => (
            <div key={widget.id} className={styles.widgetWrapper}>
              <DashboardViewWidget
                widget={widget}
                lockScrolling={false}
                showDragHandle={false}
                isEditing={false}
                onEditToggle={noop}
                updateSingleWidget={noopAsync}
              />
            </div>
          ))}
        </RGLComponent>
      </div>
    </div>
  );
};

const noop = () => {};
const noopAsync = async () => {};
